function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Map, Object, String, alertName, alertThreshold, alertType, allProjectMembers, elm, errors, isEditing, readOnly, recipients, selectedAlertKeys, thresholdInputFocused) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['subscription-section-slack-webhook'] = function({
      isReadonly = false
    } = {}) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const slackWebhookSubscriptions = $helpers.getSubscriptionsByType(SubscriptionType.SlackWebhook);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-alert-section': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-section-title': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("Slack webhooks (" + (slackWebhookSubscriptions.length) + ")");
            __jade_nodes = __jade_nodes.concat(h("a", {
              "attrs": __vjadeStringifyAttrsIfObj({
                href: 'https://api.slack.com/messaging/webhooks',
                target: `_blank`
              }),
              "class": {
                'custom-alert-section-title-info': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  icon: `info`
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  'max-width': `150px`
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Notify a slack channel via incoming webhooks");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-section-values': true,
              'custom-alert-slack-webhook-input': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = (slackWebhookSubscriptions);
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, subscription, idx) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'custom-alert-slack-webhook-row': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-input", {
                        "attrs": __vjadeStringifyAttrsIfObj({
                          'validation-status': !!subscription.error ? `invalid` : ``,
                          'error-message': subscription.error || ``,
                          placeholder: `https://hooks.slack.com/services/T000/B000/XXXX`,
                          disabled: isReadonly,
                        }),
                        "props": {
                          value: subscription.data.slack_webhook_url,
                        },
                        "on": {
                          input: ({
                            target
                          }) => $helpers.updateSubscriptionData(SubscriptionType.SlackWebhook, idx, {
                            slack_webhook_url: target.value
                          }),
                        },
                      }));
                      __jade_nodes = __jade_nodes.concat((!isReadonly) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-button", {
                          "attrs": __vjadeStringifyAttrsIfObj({
                            theme: `tertiary`,
                            icon: `trashcan`,
                            role: `button`,
                            type: `destructive`,
                          }),
                          "on": {
                            click: () => $helpers.deleteSubscription(SubscriptionType.SlackWebhook, idx),
                          },
                        }));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var idx = $$objKey;
                    if ($$obj.hasOwnProperty(idx)) {
                      $$iterated = true;
                      var subscription = $$obj[idx];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'custom-alert-slack-webhook-row': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-input", {
                            "attrs": __vjadeStringifyAttrsIfObj({
                              'validation-status': !!subscription.error ? `invalid` : ``,
                              'error-message': subscription.error || ``,
                              placeholder: `https://hooks.slack.com/services/T000/B000/XXXX`,
                              disabled: isReadonly,
                            }),
                            "props": {
                              value: subscription.data.slack_webhook_url,
                            },
                            "on": {
                              input: ({
                                target
                              }) => $helpers.updateSubscriptionData(SubscriptionType.SlackWebhook, idx, {
                                slack_webhook_url: target.value
                              }),
                            },
                          }));
                          __jade_nodes = __jade_nodes.concat((!isReadonly) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-button", {
                              "attrs": __vjadeStringifyAttrsIfObj({
                                theme: `tertiary`,
                                icon: `trashcan`,
                                role: `button`,
                                type: `destructive`,
                              }),
                              "on": {
                                click: () => $helpers.deleteSubscription(SubscriptionType.SlackWebhook, idx),
                              },
                            }));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((!isReadonly) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `secondary`,
                icon: `plus`,
                role: `button`,
              }),
              "on": {
                click: () => $helpers.createDefaultSubscription(SubscriptionType.SlackWebhook),
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Add URL");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['custom-alert-condition-operator-and-threshold'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "attrs": __vjadeStringifyAttrsIfObj({
            options: JSON.stringify(Object.keys($helpers.CUSTOM_ALERT_OPERATOR)),
            'selected-option': $helpers.getSelectedConditionOp(),
            size: `large`,
          }),
          "on": {
            change: $helpers.handleConditionOpChange,
          },
          "class": {
            'custom-alert-condition-op': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(($attr(`enable-condition-types`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`is-editing-mode`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-condition-type-text': true
              },
            }, [__vjadeSafeCode(customAlertTypeTexts[alertType])]));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'menu-width': `300`,
                options: JSON.stringify(Object.values(customAlertTypeTexts)),
                'selected-option': customAlertTypeTexts[alertType],
                size: `large`,
              }),
              "on": {
                change: $helpers.handleConditionTypeChange,
              },
              "class": {
                'custom-alert-condition-type': true
              },
            }));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-alert-condition-threshold': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
            "attrs": __vjadeStringifyAttrsIfObj({
              'max-length': `15`,
              placeholder: thresholdInputFocused ? `` : `0`,
              'input-style-overrides': JSON.stringify({
                'border': `solid 1px ${!!errors[`alertThreshold`] ? `#E4567B` : `#D8E0EA`}`,
                'border-radius': `8px`,
                'color': `#6d859e`,
                'height': `40px`,
                'min-width': `36px`,
                'padding': `6px`,
                'text-align': `right`,
              }),
            }),
            "hook": {
              insert: ({
                em
              }) => $component.setElmRef(`thresholdInput`, elm),
            },
            "props": {
              type: `string`,
              value: alertThreshold === null ? `` : `${displayThreshold}`,
            },
            "on": {
              blur: $helpers.handleThresholdBlur,
              change: $helpers.handleThresholdChange,
              focus: $helpers.handleThresholdFocus,
            },
            "class": {
              'custom-alert-condition-threshold-percent': $attr(`is-percentage-threshold`) || alertType === $helpers.CUSTOM_ALERT_TYPE.relativePercent
            },
          }));
          __jade_nodes = __jade_nodes.concat((!!errors[`alertThreshold`]) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": __vjadeStringifyAttrsIfObj({
                'always-show': true,
                placement: `top`,
                type: `error`,
              }),
            }, [__vjadeSafeCode(errors[`alertThreshold`])]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const displayThreshold = alertThreshold && ($attr(`is-percentage-threshold`) ? (alertThreshold * 100).toFixed(2) : alertThreshold);
    const keysAndValues = $attr(`results-keys-and-values`) || [];
    const selectedKeys = selectedAlertKeys || [];
    const customAlertTypeTexts = $helpers.getCustomAlertTypeTexts();
    const {
      SubscriptionType
    } = $helpers;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'custom-alert-wrapper-readonly': readOnly,
        }, {
          'custom-alert-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-alert-title': true
          },
        }, [__vjadeSafeCode($helpers.getModalTitle())])); /*  ------ read only ----- */
        __jade_nodes = __jade_nodes.concat((readOnly) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, [__vjadeSafeCode(alertName)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert me when");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (selectedKeys);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, key, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'custom-alert-condition-key': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-header': true
                            },
                          }, [__vjadeSafeCode(`${key.displayHeader} :`)]));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-text': true
                            },
                          }, [__vjadeSafeCode(key.displayValue)]));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var key = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-key': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-header': true
                                },
                              }, [__vjadeSafeCode(`${key.displayHeader} :`)]));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-text': true
                                },
                              }, [__vjadeSafeCode(key.displayValue)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("current value is");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'custom-alert-condition-threshold-percent': $attr(`is-percentage-threshold`)
                }, {
                  'custom-alert-section-values': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((((alertType) == ($helpers.CUSTOM_ALERT_TYPE.relativePercent))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + (displayThreshold) + "% " + ($helpers.getSelectedConditionOp()) + " the previous value");;
                    return __jade_nodes
                  }).call(this)) :
                  (((alertType) == ($helpers.CUSTOM_ALERT_TYPE.relativeValue))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + (displayThreshold) + " " + ($helpers.getSelectedConditionOp()) + " the previous value");;
                    return __jade_nodes
                  }).call(this)) :
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + ($helpers.getSelectedConditionOp()) + " " + (displayThreshold) + "");;
                    return __jade_nodes
                  }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("send at most once every");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, [__vjadeSafeCode($helpers.getSelectedFrequency())]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, [__vjadeSafeCode(`Email recipients (${recipients.length})`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-email-recipients-input", {
                  "key": `alert-recipients-readonly`,
                  "attrs": __vjadeStringifyAttrsIfObj({
                    borderless: true,
                    disabled: true,
                    recipients: JSON.stringify($helpers.getRecipientAttrs()),
                  }),
                  "props": {
                    projectMembersMap: new Map()
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['subscription-section-slack-webhook'].call(this, {
              isReadonly: true
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedCancel
              },
              "attrs": __vjadeStringifyAttrsIfObj({
                disabled: false,
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Close");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean))); /*  ------ end of read only ----- */ ;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    maxlength: 50,
                    placeholder: alertName === `` ? $helpers.DEFAULT_ALERT_NAME : alertName,
                    type: `text`,
                  }),
                  "props": {
                    value: isEditing ? alertName : ``
                  },
                  "on": {
                    input: $helpers.handleAlertNameChange
                  },
                  "class": Object.assign({}, {
                    'custom-alert-invalid-input': !!errors[`alertName`]
                  }, {
                    'custom-alert-name': true
                  }),
                }));
                __jade_nodes = __jade_nodes.concat((!!errors[`alertName`]) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'always-show': true,
                      placement: `top`,
                      type: `error`,
                    }),
                  }, [__vjadeSafeCode(errors[`alertName`])]));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert me when");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`is-editing-mode`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (selectedKeys);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, key, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-key': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-header': true
                              },
                            }, [__vjadeSafeCode(key.displayHeader)]));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-text': true
                              },
                            }, [__vjadeSafeCode(key.displayValue || key)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var key = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-key': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-header': true
                                  },
                                }, [__vjadeSafeCode(key.displayHeader)]));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-text': true
                                  },
                                }, [__vjadeSafeCode(key.displayValue || key)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (keysAndValues);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, key, idx) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-key': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-header': true
                              },
                            }, [__vjadeSafeCode(key.displayName)]));
                            __jade_nodes = __jade_nodes.concat((key.values.length === 1) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-text': true
                                },
                              }, [__vjadeSafeCode(key.displayValues[0])]));
                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  placement: `top`
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("This segment only has one value");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                "attrs": __vjadeStringifyAttrsIfObj({
                                  'menu-width': 300,
                                  sections: $helpers.getAlertKeyOptions(key, idx),
                                  size: `large`,
                                }),
                                "on": {
                                  change: ev => $helpers.handleConditionKeyChange(ev, idx)
                                },
                                "class": Object.assign({}, {
                                  'custom-alert-condition-key-error': $helpers.displayKeyConditionErrorByIndex(idx)
                                }, {
                                  'custom-alert-condition-key-dropdown': true
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var idx = $$objKey;
                          if ($$obj.hasOwnProperty(idx)) {
                            $$iterated = true;
                            var key = $$obj[idx];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-key': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-header': true
                                  },
                                }, [__vjadeSafeCode(key.displayName)]));
                                __jade_nodes = __jade_nodes.concat((key.values.length === 1) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'custom-alert-condition-text': true
                                    },
                                  }, [__vjadeSafeCode(key.displayValues[0])]));
                                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      placement: `top`
                                    }),
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat("This segment only has one value");;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                    "attrs": __vjadeStringifyAttrsIfObj({
                                      'menu-width': 300,
                                      sections: $helpers.getAlertKeyOptions(key, idx),
                                      size: `large`,
                                    }),
                                    "on": {
                                      change: ev => $helpers.handleConditionKeyChange(ev, idx)
                                    },
                                    "class": Object.assign({}, {
                                      'custom-alert-condition-key-error': $helpers.displayKeyConditionErrorByIndex(idx)
                                    }, {
                                      'custom-alert-condition-key-dropdown': true
                                    }),
                                  }));;
                                  return __jade_nodes
                                }).call(this)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this)));
                __jade_nodes = __jade_nodes.concat((!!errors[`alertConditionKeys`]) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      'always-show': true,
                      placement: `top`,
                      type: `error`,
                    }),
                  }, [__vjadeSafeCode(errors[`alertConditionKeys`])]));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-alert-condition-is': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("is");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(jade_mixins['custom-alert-condition-operator-and-threshold'].call(this));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("send at most once every");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'menu-width': 100,
                    options: JSON.stringify(Object.keys($helpers.CUSTOM_ALERT_FREQUENCY)),
                    'selected-option': $helpers.getSelectedFrequency(),
                    size: `large`,
                  }),
                  "on": {
                    change: $helpers.handleSelectFrequency
                  },
                  "class": {
                    'custom-alert-frequency': true
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, [__vjadeSafeCode(`Email recipients (${$helpers.getNonEmptyValidRecipientCount()})`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-email-recipients-input", {
                  "key": `alert-recipients`,
                  "attrs": __vjadeStringifyAttrsIfObj({
                    borderless: false,
                    disabled: false,
                    recipients: JSON.stringify($helpers.getRecipientAttrs()),
                  }),
                  "props": {
                    projectMembersMap: new Map(allProjectMembers.map(m => [m.email, m]))
                  },
                  "on": {
                    changed: $helpers.handleRecipientsChanged
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat((errors[`recipients`]) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    'always-show': true,
                    placement: `top`,
                    type: `error`,
                    'offset': `-30`,
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Some recipient email addresses are invalid");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(jade_mixins['subscription-section-slack-webhook'].call(this));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedCancel
              },
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `tertiary`,
                disabled: false,
              }),
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedSave
              },
              "attrs": __vjadeStringifyAttrsIfObj({
                theme: `primary`,
              }),
              "class": {
                'custom-alert-save-button': true
              },
            }, [__vjadeSafeCode(isEditing ? `Save Alert` : `Create Alert`)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Map" in locals ? locals.Map : typeof Map !== "undefined" ? Map : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "alertName" in locals ? locals.alertName : typeof alertName !== "undefined" ? alertName : undefined, "alertThreshold" in locals ? locals.alertThreshold : typeof alertThreshold !== "undefined" ? alertThreshold : undefined, "alertType" in locals ? locals.alertType : typeof alertType !== "undefined" ? alertType : undefined, "allProjectMembers" in locals ? locals.allProjectMembers : typeof allProjectMembers !== "undefined" ? allProjectMembers : undefined, "elm" in locals ? locals.elm : typeof elm !== "undefined" ? elm : undefined, "errors" in locals ? locals.errors : typeof errors !== "undefined" ? errors : undefined, "isEditing" in locals ? locals.isEditing : typeof isEditing !== "undefined" ? isEditing : undefined, "readOnly" in locals ? locals.readOnly : typeof readOnly !== "undefined" ? readOnly : undefined, "recipients" in locals ? locals.recipients : typeof recipients !== "undefined" ? recipients : undefined, "selectedAlertKeys" in locals ? locals.selectedAlertKeys : typeof selectedAlertKeys !== "undefined" ? selectedAlertKeys : undefined, "thresholdInputFocused" in locals ? locals.thresholdInputFocused : typeof thresholdInputFocused !== "undefined" ? thresholdInputFocused : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;